import React from "react";

// eslint-disable-next-line no-unused-vars
function MarketingListDocumentation({ entityName, entityNamePlural, contentType, apiEndpoint, onClose }) {
  return (
    <div className="row mb-4">
      <div className="col-lg-8 col-xl-6">
        <div className="alert alert-info" role="alert">
          <h4 className="alert-heading mb-2">
            <i className="fas fa-info-circle me-1" />
            Documentation
            <button type="button" className="btn-close float-end" aria-label="Close" onClick={onClose} />
          </h4>
          <div className="mb-3">
            <strong>Normal workflow:</strong>
            <ol className="small mb-2">
              <li>Click &quot;Create New List&quot; to start a new {entityName} list</li>
              <li>Click &quot;Edit list&quot; to add the latest {contentType}</li>
              <li>
                {'Return to this page and click "Publish" to set a slug and make it available via API. The slug '}
                {'enables the list to be accessed even when it\'s not "current," which powers the historical pages on '}
                the marketing site.
              </li>
              <li>
                {'Click "Set Current" to make it the active list served at the '}
                <code>/current</code>
                {" endpoint"}
              </li>
            </ol>
          </div>
          <div className="mb-3">
            <strong>Swap list workflow (for seamless updates):</strong>
            <ol className="small mb-2">
              <li>Create a new list while the old one remains published</li>
              <li>Edit the new list to add updated {contentType}</li>
              <li>Give the new list the same slug as the existing published list (e.g., &quot;2025-q1&quot;)</li>
              <li>When ready to go live: First unpublish the old list, then immediately publish the new list</li>
              <li>Optionally set the new list as current if needed</li>
            </ol>
            <p className="small text-muted mb-0">
              <i className="fas fa-lightbulb me-1" />
              This workflow ensures zero downtime - the API endpoint continues serving the old list until the exact
              moment you swap to the new one.
            </p>
          </div>
          <strong>Key concepts:</strong>
          <ul className="mb-0 small">
            <li>
              <strong>Published:</strong> A list is published when it has a published date. Only published lists are
              visible to anonymous users via the API
            </li>
            <li>
              <strong>Current:</strong> Marks which published list is served when requesting the &quot;current&quot;
              list
            </li>
            <li>
              <strong>Slug:</strong>{" "}
              {'Required for publishing. We suggest using format YYYY-q# (e.g., "2025-q1"). The '}
              slug &quot;current&quot; is reserved
            </li>
            <li>
              <strong>Slug uniqueness:</strong> Slugs only need to be unique among published lists. You can prepare a
              replacement list with the same slug, then unpublish the old one before publishing the new one
            </li>
            <li>Only one list can be marked as &quot;current&quot; at a time</li>
            <li>Unpublishing a current list will automatically unset it as current</li>
            <li>
              The API endpoint <code>{apiEndpoint}</code> returns the list marked as current, or falls back to the most
              recently published list if no current is set
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default MarketingListDocumentation;
